import { t } from "i18next";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { OPERATIONS_TYPE } from "../../utils/constants";
import MenuItem from "./MenuItem";

const Toolbox = ({
    handleClick,
    variables = [],
    operators = [],
    isOperatorDisabled,
}) => {
    const [constant, setConstant] = useState("");

    const handleConstantChange = (event) => {
        setConstant(event?.target?.value || "");
    };

    const custom = [
        {
            type: OPERATIONS_TYPE.VARIABLE,
            tooltip: t("parameters"),
            label: t("parameters"),
            value: "variables",
            disabled: isEmpty(variables),
            content: variables.map((variable) => ({
                type: OPERATIONS_TYPE.VARIABLE,
                label: variable.label,
                value: variable.value,
                handler: () =>
                    handleClick({
                        type: OPERATIONS_TYPE.VARIABLE,
                        label: variable.label,
                        value: variable.value,
                    }),
                displayName: variable.deployed ? (
                    <div>
                        <span className="text-tiny">{variable.label}</span>
                        <span className="ml-1 text-xxs">({t("deployed")})</span>
                    </div>
                ) : (
                    <span className="text-tiny">{variable.label}</span>
                ),
            })),
        },
        {
            type: OPERATIONS_TYPE.CONSTANT,
            tooltip: t("constants"),
            label: t("constants"),
            value: "constants",
            allowHTML: true,
            content: (
                <div className="input-group">
                    <h4 className="text-gray uppercase text-xs">
                        {t("number")}
                    </h4>
                    <input
                        type="number"
                        className="input-element"
                        value={constant}
                        onChange={handleConstantChange}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleClick({
                                    type: OPERATIONS_TYPE.CONSTANT,
                                    value: constant,
                                    label: constant,
                                });
                            }
                        }}
                    />
                    <button
                        className={`secondary-green-outline-btn w-full mt-1 ${
                            isEmpty(constant) ? "disabled" : ""
                        }`}
                        onClick={() =>
                            handleClick({
                                type: OPERATIONS_TYPE.CONSTANT,
                                value: constant,
                                label: constant,
                            })
                        }
                    >
                        {t("add")}
                    </button>
                </div>
            ),
        },
    ];

    const renderTools = (tools) => {
        return tools?.map((tool, key) => (
            <div
                key={key}
                className={`tool-btn ${
                    isOperatorDisabled(tool) ? "disabled" : ""
                }`}
                onClick={() => handleClick(tool)}
                disabled={isOperatorDisabled(tool)}
            >
                {tool.label}
            </div>
        ));
    };

    const renderMenus = (menus) => {
        return menus?.map((menu, key) => (
            <MenuItem
                key={key}
                content={menu.content}
                allowHTML={menu.allowHTML}
                disabled={menu.disabled}
            >
                <div className={`tool-btn ${menu.disabled ? "disabled" : ""}`}>
                    <span className="flex gap-2 items-center">
                        {menu.label}
                        <i className="fas fa-chevron-down" />
                    </span>
                </div>
            </MenuItem>
        ));
    };

    return (
        <>
            <div className="grid grid-cols-6"> {renderTools(operators)}</div>
            <div className="grid grid-cols-2 custom">{renderMenus(custom)}</div>
        </>
    );
};

export default Toolbox;
